module.exports = __webpack_public_path__ + "static/media/hero-3.49494a3b.jpg";